import React from 'react';

const SidebarContent = ({ section, project, setSelectedPhoto, setSelectedVideo, setSelectedOrthophoto, setSelectedModel, setSelectedPointCloud, setSelectedPlan }) => {
    const { orthophotos, videos, images, models, pointClouds, plans } = project || {};

    return (
        <div className="sidebar-content">
            {section === 'overview' && (
                <div className="info-sidebar">
                    <h2>Informations</h2>
                    <p>Vous trouverez dans les différents onglets toutes les informations liées au projet. En cas de problème, vous pouvez nous joindre par mail à <a href="mailto:contact@geodrone3d.com">contact@geodrone3d.com</a></p>
                    <p>Cette plateforme est encore en développement, n'hésitez pas à nous faire part de vos remarques.</p>
                </div>
            )}
            
            {section === 'orthophotos' && (
                <div>
                    <h2>Orthophotos</h2>
                    {orthophotos && orthophotos.length > 0 ? (
                        orthophotos.map((photo, index) => (
                            <img
                                key={index}
                                src={photo.orthothumb}
                                alt={photo.name}
                                onClick={() => setSelectedOrthophoto(photo.link)}
                                className="thumbnail"
                            />
                        ))
                    ) : (
                        <p>No orthophotos available</p>
                    )}
                </div>
            )}

            {section === 'video' && (
                <div>
                    <h2>Videos</h2>
                    {videos && videos.length > 0 ? (
                        videos.map((video, index) => (
                            <button
                                key={index}
                                onClick={() => setSelectedVideo(video.link)}
                                className="video-button"
                            >
                                {video.name}
                            </button>
                        ))
                    ) : (
                        <p>No videos available</p>
                    )}
                </div>
            )}

            {section === 'model' && (
                <div>
                    <h2>Modèles 3D</h2>
                    {models && models.length > 0 ? (
                        models.map((model, index) => (
                            <button
                                key={index}
                                onClick={() => setSelectedModel(model.link)}
                                className="model-button"
                            >
                                {model.name}
                            </button>
                        ))
                    ) : (
                        <p>No model available</p>
                    )}
                </div>
            )}

            {section === 'pointCloud' && (
                <div>
                    <h2>Nuages de points</h2>
                    {pointClouds && pointClouds.length > 0 ? (
                        pointClouds.map((pointCloud, index) => (
                            <button
                                key={index}
                                onClick={() => setSelectedPointCloud(pointCloud.link)}
                                className="pointCloud-button"
                            >
                                {pointCloud.name}
                            </button>
                        ))
                    ) : (
                        <p>No point cloud available</p>
                    )}
                </div>
            )}

            {section === 'plans' && (
                <div>
                    <h2>Plans</h2>
                    {plans && plans.length > 0 ? (
                        plans.map((plan, index) => (
                            <button
                                key={index}
                                onClick={() => setSelectedPlan(plan.file)}
                                className="plan-button"
                            >
                                {plan.name}
                            </button>
                        ))
                    ) : (
                        <p>No plans available</p>
                    )}
                </div>
            )}

            {section === 'photos' && (
                <div>
                    <h2>Photos</h2>
                    {images && images.length > 0 ? (
                        images.map((image, index) => (
                            <img
                                key={index}
                                src={image}
                                alt={`Photo ${index}`}
                                onClick={() => {
                                    console.log('Photo clicked:', image); // Debugging line
                                    setSelectedPhoto(image); // Ensure this is called
                                }}
                                className="thumbnail"
                            />
                        ))
                    ) : (
                        <p>No photos available</p>
                    )}
                </div>
            )}

        </div>
    );
};

export default SidebarContent;
